var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "500px",
        closeColor: "#8e8e8e",
        backgroundColor: "white",
        "content-class": "atendimento-inner-modal"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: _vm.close } },
                [_vm._v(" Fechar ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.name || "Foto do contato"))
          ])
        ]),
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              staticClass:
                "profile-picture-body d-flex justify-center align-center pa-4"
            },
            [
              _c("img", {
                staticClass: "profile-picture-image",
                attrs: { src: _vm.imageUrl, alt: _vm.name }
              })
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }